import React, { useEffect } from "react";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { Moment } from "moment";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { MailexUploadRulesDto } from "../../../models/MailexUploadRulesDto";

interface IMailexCreateRulesStepProps {
	rules: MailexUploadRulesDto;
	setRules: (data: MailexUploadRulesDto) => void;
	validate: (value: boolean) => void;
	lockTemplate?: boolean;
}

export const MailexCreateRulesStep: React.FC<IMailexCreateRulesStepProps> = ({
	rules,
	setRules,
	validate,
	lockTemplate,
}) => {
	const handleChange = (newValue: Moment | null) => {
		setRules({ ...rules, datetime: newValue?.toDate() });
	};

	useEffect(() => {
		if (rules.datetime && rules.description && rules.template) validate(true);
		else validate(false);
	}, [rules, validate]);

	return (
		<div style={{ paddingTop: "5px" }}>
			{/* <FormControl>
				<InputLabel required={true} htmlFor="description">
					Description
				</InputLabel>
				<Input
					id="description"
					aria-describedby="helper-description"
					value={rules.description}
					required
					onChange={(event) =>
						setRules({ ...rules, description: event.target.value })
					}
				/>
				<FormHelperText id="helper-description">
					Define this mail set with some keywords.
				</FormHelperText>
			</FormControl> 
			<br />
			<br /> */}
			<FormControl fullWidth>
				<InputLabel required={true} htmlFor="template">
					Template
				</InputLabel>
				<Select
					id="template"
					value={rules.template}
					label="Template"
					style={{ maxWidth: "260px" }}
					onChange={(event) =>
						setRules({
							...rules,
							template: event.target.value,
							description: event.target.value,
						})
					}
					disabled={lockTemplate}
				>
					<MenuItem value={"Herinnering"}>Herinnering</MenuItem>
					<MenuItem value={"Aanmaning"}>Aanmaning</MenuItem>
					<MenuItem value={"Stornering"}>Stornering</MenuItem>
					<MenuItem value={"Prolongatie"}>Prolongatie</MenuItem>
					<MenuItem value={"Vooraankondiging"}>Vooraankondiging</MenuItem>
					<MenuItem value={"Regular"}>Regulier</MenuItem>
				</Select>
			</FormControl>
			<LocalizationProvider dateAdapter={AdapterMoment}>
				<br />
				<br />
				<MobileDatePicker
					minDate={moment()}
					label="Date"
					inputFormat="MM/DD/YYYY"
					value={moment(rules.datetime)}
					onChange={handleChange}
					renderInput={(params) => (
						<TextField
							{...params}
							helperText="When should the set be delivered?"
						/>
					)}
				/>

				<br />
				<br />
				<MobileTimePicker
					minTime={
						moment().isSameOrAfter(moment(rules.datetime))
							? moment()
							: moment("2000/01/01 00:00:00")
					}
					label="Time"
					value={moment(rules.datetime)}
					onChange={handleChange}
					renderInput={(params) => (
						<TextField {...params} helperText="Aaaand at what time?" />
					)}
				/>
			</LocalizationProvider>
		</div>
	);
};
